export const INTERFACE_TRACK_LIST = [
    {
        url: '/mcdonald/store/v1/list',
        params: ['list'],
    },
    {
        url: '/mcdonald/menu/v1/list',
        params: ['list'],
    },
    {
        url: '/mcdonald/standard/order/v1/order/preOrder',
        params: ['payUrl'],
        customParamsCheckFunc: data => {
            if (!data?.payUrl && data?.outOfStockGoods && data?.outOfStockGoods.length > 0) {
                return false;
            } else if (!data?.payUrl) {
                return true;
            }
        },
    },
    {
        url: '/mcdonald/standard/order/v1/detail',
        params: ['status'],
    },
    {
        url: '/recharge/product/v1/detail',
        params: ['skuList'],
    },
    {
        url: '/recharge/order/v1/waitForPay',
        params: ['payPrice'],
    },
    {
        url: '/recharge/order/v1/createOrder',
        params: ['orderId'],
    },
];
